// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page[data-v-53176155] {\n  width: 100%;\n  display: flex;\n  height: calc(100vh - 148px);\n  overflow: hidden;\n}\n.page .leftBox[data-v-53176155] {\n  width: 300px;\n  height: 100%;\n  overflow-y: auto;\n}\n.page .leftBox[data-v-53176155] .ant-card-body {\n  padding: 20px 8px !important;\n}\n.page .rightBox[data-v-53176155] {\n  flex: 1;\n  overflow-y: auto;\n  height: 100%;\n  padding: 0 20px;\n}", ""]);
// Exports
module.exports = exports;
